import { z } from "zod";
import { defineStepConfig } from "../../registry/helpers";
import { entityOfType } from "../../utils/system-entities";
import { SystemEntity } from "@erp/shared-types";

export const ingestMicrosoftGraphEmailStep = defineStepConfig({
  type: "ingest_microsoft_graph_email",
  name: "Ingest Microsoft Graph Email",
  description: "Fetch email from Microsoft Graph and store in database",
  category: "Integration",

  inputSchema: z.object({
    tenantId: z.string(),
    mailboxUpn: z.email(),
    messageId: z.string(),
  }),

  outputSchema: z.object({
    // Optional when skipping self-sent emails (they're already in OutboundEmail)
    inboundEmail: entityOfType(SystemEntity.INBOUND_EMAIL).optional(),
    documents: z.array(entityOfType(SystemEntity.CORE_DOCUMENT)),
    attachmentCount: z.number(),
    // Generic early exit convention
    _workflowComplete: z.boolean().optional(),
    _workflowCompleteReason: z.string().optional(),
  }),

  configSchema: z.object({}), // No config needed for now

  emits: [] as const,

  execution: {
    startToCloseTimeout: "2 minutes",
    retry: {
      maximumAttempts: 1,
    },
    nonRetryableErrorTypes: ["ErrorItemNotFound", "ErrorAccessDenied"],
  },
});
